import { LocalizedString } from '@onrunning/backstage-models';

export const defaultMessages = {
  accountSelector: {
    heading1: 'You are currently logged in as {username}.',
    heading2: "Please select and confirm the account you'd like to log in as.",
    heading3: 'You can always change your account on the very right in the header menu.',
    cancel_button_label: 'Cancel',
    confirm_button_label: 'Confirm',
  },
  newRelease: {
    title: "What's new?",
    confirm_button_label: 'Finish',
    subscription_prompt: "If you'd like to subscribe, please click here",
    subscription_successful: 'You have successfully subscribed',
    subscription_failed: 'Something went wrong, you have not subscribed',
    feature_release_not_found: 'Feature release not found',
  },
  viewAccounting: {
    accountBalanceQuestion: 'Do you want an overview in PDF of your account statement?',
    EURequest: 'EU please request',
    EUStatementRequestEmail: "ar{'@'}on-running.com",
    EUStatementRequestSubject: 'EU Account Statement',
    USAndCanadaRequest: 'US & Canada please request',
    USAndCanadaStatementRequestEmail: "usfinance{'@'}on.com",
    USAndCanadaStatementRequestSubject: 'US/CA Account Statement',
    here: 'here',
    title: 'Accounting',
    credit_card_limit: 'Credit card limit',
    credit_card_limit_tooltip: 'Limit: ',
    credit_card_limit_exceeded: 'You have exceeded your credit card payment limit.',
    order_button: 'Go to orders',
    no_accounting_documents_message: 'No documents were found',
    account_balance: 'Account balance',
    balance_overdue: 'Balance overdue',
    account_balance_tootltip:
      'Takes into consideration the total of all open invoices, credit notes, journals, and unsettled payments.',
    balance_overdue_tootltip:
      'Takes into consideration the sum of all open invoices, credit notes, journals, and payments past their due date.',
    document_status: {
      settled: 'Settled',
      in_progress: 'In Progress',
      open: 'Open',
      overdue: 'Overdue',
      soon: 'Soon',
    },
    columns: {
      document_number: 'Document #',
      status: 'Status',
      paid_date: 'Paid Date',
      document_date: 'Document Date',
      due_date: 'Due Date',
      order_number: 'Order #',
      customer_purchase_order_number: 'Customer PO#',
      total_price: 'Document Total',
      outstanding_price: 'Outstanding Value',
      total_if_paid_today: 'Total if paid today',
      download: 'Open',
    },
    dynamics_legend:
      "Note: Invoices from after 01 of May 2021 are visible in the order overview.<br> Do you want an overview in a PDF with an accounting statement? <br> EU please request it <a class='green-button' href='mailto:backstage{'@'}on-running.com?subject=EU Account Statement'>here</a><br> US please request it <a href='mailto:backstage{'@'}on-running.com?subject=US Account Statement' class='green-button'>here</a>",
    pay_button: 'Pay',
    checking_3ds_result: 'Checking 3DS result',
    viewOptions: {
      open: 'Open',
      closed: 'Closed',
    },
    document_selection_limit_reached: 'You can select a maximum of 20 documents',
  },
  viewSummary: {
    range: 'Overview from {from} to {to}',
    gender: 'Gender',
    noData: 'There are no matching orders.',
    stylesSplit: 'Styles Split',
    totalPriceLabel: 'Total price',
    totalQuantityLabel: 'Total quantity',
    totalPriceDisclaimer:
      'The total amount does not include discounts and taxes, please check the final price on the invoice.',
    totalQuantity: {
      shoes: 'Shoes Total Quantity',
      apparel: 'Apparel Total Quantity',
      accessories: 'Accessories Total Quantity',
    },
    totalPrice: {
      shoes: 'Shoes Total Value',
      apparel: 'Apparel Total Value',
      accessories: 'Accessories Total Value',
    },
    totalPercentage: {
      shoes: 'Shoes Total Value (%)',
      apparel: 'Apparel Total Value (%)',
      accessories: 'Accessories Total Value (%)',
    },
    genderSplits: {
      'shoes-unisex': 'Shoes Unisex',
      'shoes-male': 'Shoes Men',
      'shoes-female': 'Shoes Women',
      'shoes-youth': 'Shoes Youth',
      'shoes-kids': 'Shoes Kids',
      'shoes-toddler': 'Shoes Toddler',
      'apparel-unisex': 'Apparel Unisex',
      'apparel-male': 'Apparel Men',
      'apparel-female': 'Apparel Women',
      'apparel-youth': 'Apparel Youth',
      'apparel-kids': 'Apparel Kids',
      'accessories-unisex': 'Accessories Unisex',
      'accessories-male': 'Accessories Men',
      'accessories-female': 'Accessories Women',
      'accessories-youth': 'Accessories Youth',
      'accessories-kids': 'Accessories Kids',
    },
  },
  viewOrders: {
    title: 'Order history',
    'title-suffix': 'orders',
    missingDocument: 'Unfortunately the document is not available at the moment.',
    viewOptions: {
      orders: 'All Orders',
      items: 'Backorder',
    },
    order_duplication: {
      duplicate_orders_title: 'Duplicate orders',
      select_accounts_title: 'Select accounts',
      submit_popup_title: 'The following drafts were created successfully.',
      update_note: 'Please make sure to update requested date and PO number in the newly created drafts.',
      orders_restriction_note: 'You are allowed to duplicate max 10 orders',
      accounts_restriction_note: 'You are allowed to select max 10 accounts',
      errors: {
        order_not_found: 'Order not found, this order will not be duplicated',
        order_type_unavailable: 'Order type unavailable, this order will not be duplicated',
        assortment_fetch_failed:
          'There is an error in fetching the assortment for the order, this order will not be duplicated',
        draft_creation_failed: 'Draft creation failed',
        user_unauthorized: 'Unauthorized user',
        duplicate_account: 'Duplicate account',
        no_assortment_available: 'No assortment available',
        assortment_unavailable: 'Does not have access to {productName} and this item will not be duplicated',
        order_type_not_duplicatable: 'Order type not duplicatable',
      },
    },
    download: {
      order_selection_exceeded: 'You are allowed to download maximum 500 orders',
      button_label: 'Download as .xlsx',
      file_name: 'Backstage Orders',
      selectable_fields_popup_title: 'Export',
      selectable_fields_popup_description: 'Select fields below, then export your custom file',
      selectable_fields_popup_total_info: '{total} fields available — scroll down to see more',
      select_all: 'Select all',
      export_button_label: 'Export',
      selectable_fields: {
        salesOrderNumber: 'Sales Order Number',
        requestedReceiptDate: 'Requested Receipt Date',
        description: 'Description',
        quantityShipped: 'Quantity Shipped',
        quantityCancelled: 'Quantity Cancelled',
        quantityOrdered: 'Quantity Ordered',
        orderLineStatus: 'Order Line Status',
        translotId: 'Translot ID',
        eanNumber: 'EAN Number',
        brand: 'Brand',
        selection: 'Selection',
        vertical: 'Vertical',
        itemNumber: 'Item Number',
        fabricCode: 'Fabric Code',
        gender: 'Gender',
        defaultItemGroup: 'Default Item Group',
        fabricDescription: 'Fabric Description',
        nrfColor: 'NRF Color',
        primaryColor: 'Primary Color',
        fedas: 'Fedas',
        sizeCode: 'Size Code',
        usSize: 'US Size',
        euSize: 'EU Size',
        jpSize: 'JP Size',
        brSize: 'BR Size',
        ukSize: 'UK Size',
        mxSize: 'MX Size',
        nrfSize: 'NRF Size',
        phaseInDate: 'Phase In Date',
        phaseOutDate: 'Phase Out Date',
        countryOfOrigin: 'Country Of Origin',
        advertisedOrigin: 'Advertised Origin',
        customsTariffNumber: 'Customs Tariff Number',
        retailerPrice: 'Retailer Price',
        wholesalePrice: 'Wholesale Price',
        productMaterialDescription: 'Product Material Description',
        defaultItemGroupUpperUnit: 'Default Item Group Upper Unit',
        defaultItemGroupBottomUnit: 'Default Item Group Bottom Unit',
        defaultItemGroupMembrane: 'Default Item Group Membrane',
        widthStandard: 'Width Standard',
        heelToeDrop: 'Heel Toe Drop',
        defaultItemGroupMaterialComposition: 'Default Item Group Material Composition',
        defaultItemGroupProductMaterialComposition: 'Default Item Group Product Material Composition',
        defaultItemGroupHighlightedFeaturesOfGarment: 'Default Item Group Highlighted Features Of Garment',
        engMarketingDescription: 'ENG Marketing Description',
        deMarketingDescription: 'DE Marketing Description',
        frMarketingDescription: 'FR Marketing Description',
        nlMarketingDescription: 'NL Marketing Description',
        espMarketingDescription: 'ESP Marketing Description',
        jpMarketingDescription: 'JP Marketing Description',
        ptMarketingDescription: 'PT Marketing Description',
        marketingColor: 'Marketing Color',
        consumerPackageHeight: 'Consumer Package Height',
        consumerPackageLength: 'Consumer Package Length',
        consumerPackageWidth: 'Consumer Package Width',
        weightGrams: 'Weight Grams',
        netWeightOunces: 'Net Weight Ounces',
        defaultItemGroupUnitOfMeasure: 'Default Item Group Unit Of Measure',
        defaultItemGroupRecordType: 'Default Item Group Record Type',
        season: 'Season',
      },
    },
    overview: {
      filter: {
        equals: 'Overview on {from}',
        greaterThan: 'Overview since {from}',
        greaterThanOrEqual: 'Overview since {from}',
        lessThanOrEqual: 'Overview until {from}',
        lessThan: 'Overview until {from}',
        notEqual: 'Overview except on {from}',
        inRange: 'Overview from {from} to {to}',
        blank: 'Overview',
        notBlank: 'Overview',
        undefined: 'Overview',
      },
      details: 'Details',
      total_items: 'Total items ordered',
      total_items_tooltip: 'Please set a filter on the requested date column to see the total.',
    },
    items_list_columns: {
      item_number: 'Item Number',
      description: 'Description',
      order_number: 'Order Number',
      order_type: 'Order type',
      totalToBeDelivered: 'Quantity',
      requested_date: 'Requested Date',
      item_status: 'Status',
      refillDate: 'Estimated refill date',
      customer_po_number: 'Customer PO #',
    },
    item_status: {
      notShipped: 'Not Shipped',
    },
    order_type: {
      blockorder: 'Blockorder',
      bulks: 'Bulks',
      'demo sets': 'Demo Sets',
      'drop ship': 'Drop ship',
      'pre-order': 'Pre-Order',
      'pre-Order-multiple': 'Multiple Pre-Order',
      're-order': 'Re-Order',
      replacement: 'Replacement',
      return: 'Return',
      warranty: 'Warranty',
      'last season': 'Last Season',
      'special projects': 'Special Projects',
    },
    order_status: {
      Cancelled: 'Cancelled',
      closed: 'Closed',
      error: 'Error',
      hold: 'Hold',
      'in progress': 'In progress',
      not_submitted: 'Not submitted',
      open: 'Open',
      'partially complete': 'Partially completed',
      'Partially invoiced': 'Partially invoiced',
      'Partially shipped': 'Partially shipped',
      retry: 'Retry',
      submitted: 'Submitted',
      submitting: 'Submitting',
      Canceled: 'Cancelled',
      canceled: 'Cancelled',
      backorder: 'Open',
      invoiced: 'Invoiced',
      delivered: 'Shipped',
      'partially invoiced': 'Partially invoiced',
      'partially shipped': 'Partially shipped',
      'update in progress': 'Update in progress',
      created_in_dynamics: 'In progress',
      ready_to_submit: 'In progress',
      in_submission: 'In progress',
      confirmed_in_dynamics: 'In Progress',
    },
    place_new_order: 'Place new order',
    no_orders_message: 'No orders were found',
    no_items_message: 'No items were found',
    check_availability: 'Check availability',
    orders_list_columns: {
      ship_date: 'Ship date',
      order_date: 'Order date',
      order_type: 'Type',
      order_total: 'Order total',
      order_status: 'Status',
      order_document_status: 'Order document status',
      quantity_shipped: 'Quantity shipped',
      quantity_to_ship: 'Quantity to ship',
      customer_po_number: 'Customer PO #',
      order_confirmation: 'Order confirmation',
      order_pdf: 'PDF',
      sales_order_number: 'Sales order #',
      quantity_total: 'Quantity total',
      invoice: 'Invoice',
      credit_note: 'Credit note',
      retry_attempts: 'Retry attempts',
      last_execution_id: 'Last execution id',
      created_at: 'Created Date',
      actions: 'Actions',
      customer_name: 'Customer name',
      customer_number: 'Customer number',
    },
    place_new_order_button: 'Place new order',
    duplicate_order_button: 'Duplicate (10 max)',
    check_availability_button: 'Check availability',
    create_draft_success:
      '<span class="snotify-icon snotify-icon--warning"></span>{successCount}/{total} {orderType} drafts were created successfully.<br>Please, go to the Order overview page to submit each order separately.<br><br><strong data-cy="draft-numbers">{draftLinks}</strong>',
    create_draft_error: 'There was an error creating your draft/s, please try again later',
    edit_action_tooltip_title: 'Change until {time}',
  },
  tutorialGuidance: {
    next_action: 'Next →',
    previous_action: '← Previous',
    done_action: 'Done',
    play_video: 'Play video',
  },
  viewLaunchCalendar: {
    pricat: {
      download_pricat_button: 'PRICAT',
      comeback_later_message: 'Please come back again in 10 - 15 min. Your pricat is being generated.',
      error_message: 'Something went wrong, pricat is not available, please contact your sales representative.',
      color: 'Color',
      country_of_origin: 'Country of Origin',
      currency_code: 'Currency Code',
      drop_out_date: 'Drop Out Date',
      ean_barcode: 'EAN Barcode',
      gender: 'Gender',
      item_category: 'Item Category',
      item_code: 'Item Code',
      item_variant_code: 'Item Variant Code',
      itemId: 'Item ID',
      model: 'Model',
      order_number: 'Order Number',
      phase_in_date: 'Phase In Date',
      pre_order_worksheet_name: 'Pre Order Items',
      pricat_worksheet_name: 'Pricat Items',
      pricat: 'PRICAT',
      model_name: 'Model Name',
      quantity: 'Quantity',
      requested_receipt_date: 'Requested Receipt Date',
      retail_price: 'Retail Price',
      size: 'Size',
      selection: 'Selection',
      tariff_code: 'Tariff Code',
      vertical: 'Vertical',
      wholesale_price: 'Wholesale Price',
    },
    launch_calendar_button: 'Launch calendar',
    launch_calendar_title: 'Launch Overview',
    shoes: 'Footwear',
    apparel: 'Apparel',
    accessories: 'Accessories',
    season_subtitle: 'Launch date',
    no_products: 'No products available yet',
    new_date: 'New date',
    seasons: {
      ss: 'Spring / Summer 20{year}',
      fw: 'Fall / Winter 20{year}',
    },
  },
  oneTimeAddress: {
    default: {
      label: 'Default Address',
      title: 'Shipping to',
      btn_label: 'Ship to one time address',
      popup_title: 'Add one time address',
    },
    label_request: {
      title: 'Label Address',
      btn_label: 'Label address for one-time address',
    },
    pickup_request: {
      title: 'Picking up from',
      btn_label: 'Pick up from one-time address',
    },
  },
  viewOrder: {
    city: 'City',
    price: 'Price',
    state: 'State',
    title: 'Details',
    country: 'Country',
    post_code: 'Post code',
    sales_tax: 'Sales tax (%)',
    ship_date: 'Ship date',
    edit_order: 'Edit Order',
    order_date: 'Order date',
    description: 'Description',
    size: 'Size',
    item_number: 'Item number',
    order_total: 'Total WSP',
    not_available: 'Not available',
    order_header: 'Order Headers',
    order_lines: 'Order Lines',
    order_gross_total_message:
      'The total does not include taxes and discounts, please check the invoice to see order net total.',
    dropship_disabled_for_account_note:
      'Please note that shipping to a different delivery address (drop ship) is not possible for the time being. Please reach out to your sales representative if you have any questions.',
    update_order_note: 'Please note that it can take up to 30 minutes for updates to appear in Backstage.',
    total_price: 'Total Price',
    documents: 'Documents',
    delivery_name: 'Delivery name',
    edit_shipping: 'Edit Shipping',
    submit_button: 'Submit order',
    submit_button_disabled_rrd: 'Submit is disabled because the requested receipt date is out of season',
    reorder_warning_message: 'Due to Warehouse switching, the Re-order will be back on 2026-03-02.',
    submit_button_disabled_acc_onhold:
      'You are not able to submit an order. Please reach out to accounts receivables team',
    edit_button: 'Save order',
    order_subtotal: 'Order subtotal',
    street_address: 'Street address',
    street_address_description: 'Street address description',
    tracking_codes: 'Tracking codes',
    quantity_ordered: 'Quantity ordered',
    quantity_shipped: 'Quantity shipped',
    quantity_cancelled: 'Quantity cancelled',
    quantity_packed: 'Quantity shipped',
    quantity_updated: 'Quantity updated',
    launch_date: 'Launch date',
    ean: 'EAN',
    tracking: 'Track',
    tracking_quantity: 'Quantity',
    tracking_number_missing: 'Tracking number is not available',
    sales_order_type: 'Sales orders type',
    sales_order_document_status: 'Order document status',
    shipping_charged: 'Shipping charged',
    standard_discount: 'Standard discount (%)',
    customer_po_number: 'Customer PO #',
    customer_number: 'Customer number',
    edit_order_address:
      'If you want to ship this order to a different delivery address, please <span>click here!</span>',
    pre_order_discount: 'Pre-order discount (%)',
    sales_order_number: 'Sales order #',
    early_bird_discount: 'Early bird discount (%)',
    visibility_discount: 'Visibility discount (%)',
    on_final_order_total: 'On final order total',
    total_discount_price: 'Total discount price',
    total_items_in_order: 'Total quantity of items on order',
    applicable_us_charges: 'Applicable U.S. shipping charges will appear on invoice',
    quantity_left_to_pack: 'Quantity left to pack',
    submit_reminder_popup_title: 'Do you want to submit your order or save it for later?',
    submit_order_success: 'Thank you! Your order was submitted.',
    status: 'Status',
    contact: 'Contact',
    order_line_status: 'Order line status',
    line_status: {
      Backorder: 'Open',
      Open: 'Open',
      Cancelled: 'Cancelled',
      Delivered: 'Delivered',
      Invoiced: 'Invoiced',
      'Partially delivered': 'Open',
      'Partially invoiced': 'Open',
    },
    shipments: {
      title: 'Shipments',
      shipments_excel_tab_title: 'Shipments',
      columns: {
        shipment_number: 'Shipment number',
        quantity_shipped: 'Quantity shipped',
        carrier_service: 'Carrier',
        packing_slip: 'Packing slip',
      },
      no_shipments_yet: 'No shipment has been made yet',
    },
    item_shipment_details_selector: {
      all_items: 'All items',
    },
    only_decrease_quantities:
      'Pre-order is outside the sell-in period, you can only decrease quantities or remove items',
    overview: 'Overview',
    items: 'items',
    terms_and_conditions:
      'All On products are sold by On according to terms and conditions as outlined in the Selective Partnership Agreement (SPA).<br>By placing orders, you are agreeing to these terms and you acknowledge that you have received, read, and understood the SPA',
    default_or: 'Or',
    shipping_to: 'Shipping to:',
    documents_grid: {
      confirmation_title: 'Confirmation',
      packing_slips_title: 'Packing Slips',
      invoices_title: 'Invoices',
      loading_documents: 'Loading documents...',
    },
    confirmation_modal: {
      go_back: 'Go back',
      proceed: 'Proceed',
      size: 'Size',
      quantity: 'Quantity',
      very_low_stock_title:
        'Please note that the following item is at high risk of not being fulfilled on time due to very low stock availability: | Please note that the following {count} items are is at high risk of not being fulfilled on time due to very low stock availability:',
      no_stock_title:
        'Please note that the following {count} item is out of stock: | Please note that the following {count} items are out of stock:',
    },
  },
  viewCases: {
    grid_columns: {
      status: 'Status',
      subject: 'Subject',
      case_number: 'Case number',
      created_date: 'Created date',
      items_total_quantity: 'Total quantity',
      items_open: 'Items open',
      items_approved: 'Items approved',
      items_declined: 'Items declined',
      on_reference: 'On reference',
      return_pdf: 'Return PDF',
      credit_note: 'Credit note',
    },
    similar_image_uploaded: 'Uploaded image already exists',
    no_cases_message: 'No cases were found',
    page_title_return: 'Return cases',
    page_title_warranty: 'Warranty cases',
    create_return_case_button: 'New return case',
    create_warranty_case_button: 'New warranty case',
    all_cases: 'All cases',
    large_warranty_legend_title: 'Large warranty claim',
    large_warranty_legend_description:
      "if you need to claim a defective batch (same item and same defect raison), please contact us at <a href='mailto:eu_customerservice{'@'}on-running.com?subject=Defective Batch Warranty' target='_blank'>eu_customerservice{'@'}on-running.com</a> - no need to fill out a claim on Backstage.",
    laces_warranty_legend_title: 'Laces',
    laces_warranty_legend_description:
      "If you need to claim a pair of laces, please do it <a href='https://customer-service.on-running.com/en-de/warranty-claims' target='_blank'>here</a>. For more information, you can <a href='https://drive.google.com/file/d/1ytoeiNycdnnDwuEBsv8mha6eXJHgG_Gg/view' target='_blank'>watch this short tutorial.",
  },
  addCase: {
    button_continue: 'Proceed',
    case_processing_delay_enabled: 'true',
    case_processing_delay: 'Due to our backlog, cases submitted today will only be processed from mid of August',
    sales_rep_disabled: 'Sorry, you are currently not allowed to perform this action.',
  },
  viewCase: {
    page_title_new_prefix: 'New',
    page_title_return: 'Return case',
    page_title_warranty: 'Warranty case',
    case_number: 'Case number',
    item_number: 'Item number',
    edit_button: 'Back',
    item_product_group: 'Product group',
    item_description: 'Item description',
    item_quantity: 'Quantity',
    item_status_label: 'Status',
    item_status: {
      approved: 'Approved',
      closed: 'Closed',
      declined: 'Declined',
      open: 'Open',
      submitted: 'Submitted',
    },
    return_reason: 'Return Reason',
    run_distance_titles: [
      'unused',
      'all day wear / did not use for running',
      '0 - 50 km (0 - 31 mi)',
      '50 - 100 km (31 - 62 mi)',
      '100 - 200 km (62 - 124 mi)',
      '200 - 300 km (124 - 186 mi)',
      '300 - 400 km (186 - 248 mi)',
      '400 - 600 km (248 - 372 mi)',
      '600 - 800 km (372 - 497 mi)',
      '>800 km (>497 mi)',
    ],
    return_parcel_count: '* How many parcels/ packages will be returned',
    purchase_date: 'Purchase date',
    mandatory_fields: 'Mandatory fields*',
    image_upload_error: 'Something went wrong while uploading the image. Please try again.',
    duplicate_image_error: 'This image has already been uploaded. Please use a different one',
    images: {
      shoes: {
        validation_label: '* Please attach {minImageCount} images (defect/size label /sole, min. 100 KB max. 8 MB)',
        optional_label: 'Please upload photos of the soles, the inner tag, the defect (min. 100 KB max. 8 MB)',
        soles_label: 'Upload <b>soles</b> here',
        inner_tag_label: 'Upload <b>inner tag</b> here',
        defect_label: 'Upload <b>defect</b> here',
      },
      apparel: {
        validation_label: '* Please attach {minImageCount} images (min. 100KB, max. 8 MB)',
        optional_label: 'Please upload photos of the inner tag, the defect (min. 100KB max. 8 MB)',
        inner_tag_label: 'Upload <b>inner tag</b> here',
        defect_label: 'Upload <b>defect</b> here',
      },
      accessories: {
        validation_label: '* Please attach {minImageCount} images (max. 8 MB)',
        optional_label: 'Please upload photos of the inner tag, the defect (min. 100KB max. 8 MB)',
        inner_tag_label: 'Upload <b>inner tag</b> here',
        defect_label: 'Upload <b>defect</b> here',
      },
    },
    comments: 'Additional details',
    comments_optional: 'Additional details (optional)',
    comments_note: '* If images are not attached, please describe in details the defect reason.',
    submit_case_button: 'Submit case',
    image_validation_error_message: 'Please attach {minImageCount} product images.',
    submit_return_success:
      'Thank you! Your return case inquiry was submitted. You will receive an email confirmation shortly with your return case number. Please check the status of your case on return overview page.',
    submit_warranty_success:
      'Thank you! Your warranty case inquiry was submitted. You will receive an email confirmation shortly with your warranty case number. Please check the status of your case on warranty overview page.',
    case_is_refund_label: 'I want a credit',
    case_is_replacement_label: 'I want a replacement',
    case_submitted_date: 'Submitted date',
    case_refund_status_label: 'Refund Status',
    case_refund_status: {
      'refund requested': 'Refund requested',
    },
    case_status_label: 'Status',
    case_status: {
      open: 'Open',
      approved: 'Approved',
      'assigned to rep': 'Assigned to rep',
      'awaiting customer feedback': 'Awaiting Customer Feedback',
      'awaiting internal feedback': 'Awaiting Internal Feedback',
      'awaiting photos': 'Awaiting Photos',
      'awaiting return': 'Awaiting Return',
      'awaiting warehouse feedback': 'Awaiting warehouse feedback',
      closed: 'Closed',
      "customer's reply": "Customer's reply",
      declined: 'Declined',
      error: 'Failed to submit case',
      escalated: 'Escalated',
      'failed to submit return order': 'Failed to submit return order',
      failed_to_submit_return_order: 'Failed to submit return order',
      'in progress': 'In Progress',
      max_retry_reached: 'In Progress',
      new: 'New',
      'no action needed': 'No action needed',
      not_submitted: 'Not Submitted',
      'partial refund': 'Partial refund',
      'reply received': 'Reply Received',
      retry: 'In Progress',
      submitting: 'Submitted',
      'waiting for approval': 'Waiting for approval',
    },
    case_line_status_label: 'Status',
    case_line_status: {
      open: 'Open',
      approved: 'Approved',
      declined: 'Declined',
      closed: 'Closed',
      submitted: 'Submitted',
    },
    file_size_exceeded: 'Uploaded File size exceeded the allowed limit of {maxFileSize}MB.',
    factory_code: 'Factory Code',
    factory_code_label_shoes: 'Factory Code (Not available for all shoes)',
    factory_code_label_apparel: 'Factory Code',
    factory_code_label_accessories: 'Factory Code',
    factory_code_placeholder_shoes: 'Three letters shown on the inside of the tongue',
    factory_code_placeholder_apparel: '',
    factory_code_placeholder_accessories: '',
    distance_run: 'Distance run',
    distance_run_label_shoes: 'Distance run',
    distance_run_label_apparel: 'Distance run',
    distance_run_label_accessories: 'Distance run',
    distance_run_placeholder_shoes: '',
    distance_run_placeholder_apparel: '',
    distance_run_placeholder_accessories: '',
    defect_reason: 'Defect reason',
    defect_reason_label_shoes: 'Defect reason',
    defect_reason_label_apparel: 'Defect reason',
    defect_reason_label_accessories: 'Defect reason',
    defect_reason_placeholder_shoes: '',
    defect_reason_placeholder_apparel: '',
    defect_reason_placeholder_accessories: '',
    product_code: 'Production code',
    product_code_label_shoes: 'Production code',
    product_code_label_apparel: 'Production code',
    product_code_label_accessories: 'Production code',
    product_code_placeholder_shoes: 'Two letters shown on the inside of the tongue',
    product_code_placeholder_apparel: '4 letters shown underneath the label',
    product_code_placeholder_accessories: '4 letters shown underneath the label',
  },
  viewDashboard: {
    title: 'Dashboard',
  },
  global: {
    minutes_short: 'min',
    seconds_short: 'sec',
    contact_id_missing_title: 'Please select a contact person',
    contact_id_missing_subtitle: 'Select one contact before proceeding',
    error: 'Oops, an unexpected error occurred. Please try again later or contact us.',
    error_submitting_draft: 'There was an error submitting your draft/s, please try again later',
    error_creating_draft: 'There was an error creating your draft/s, please try again later',
    error_saving_draft: 'There was an error saving your draft/s, please try again later',
    error_updating_order: 'There was an error updating your order, please try again later',
    init_info_missing: 'Something went wrong to load initial information, please try again later or contact us.',
    shoes: 'Shoes',
    apparel: 'Apparel',
    success: 'Success',
    accessories: 'Accessories',
    close_button: 'Close',
    cancel_button: 'Cancel',
    exit_button: 'Exit',
    edit_button: 'Edit',
    select_placeholder: 'Select an option',
    datepicker_placeholder: 'dd/mm/yyyy',
    save_button: 'Save',
    delete_button: 'Delete',
    continue_button: 'Continue',
    apply_button: 'Apply',
    download_button: 'Download',
    select_button: 'Select',
    deselect_all_button: 'Deselect all',
    actions_button: 'Actions',
    next_button: 'Next',
    duplicate_button: 'Duplicate',
    submit_reminder_popup: {
      delete_button: 'Delete',
      submit_button: 'Submit',
      save_for_later_button: 'Save for later',
    },
    grids: {
      clear_all_filters_button: 'Clear filters',
    },
    clear_all_button_filter: 'Clear all',
    select_all_button_filter: 'Select all',
    languages: {
      de: 'Deutsch',
      es: 'Español',
      'es-419': 'Español (Latinoamérica)',
      fr: 'Français (Europe)',
      it: 'Italiano',
      ja: '日本語',
      nl: 'Nederlands',
      pt: 'Português',
      'pt-PT': 'Português (Portugal)',
      'en-CA': 'English (Canada)',
      'en-GB': 'English (UK, Australia)',
      'en-US': 'English (USA)',
      'fr-CA': 'Français (Canada)',
      'zh-CN': '中文',
      ko: '한국인',
      // not yet
      // nb: 'Norsk',
      // sv: 'Svensk',
      // da: 'Dansk'
    } as any as LocalizedString, // ToDo remove as any as soon as we can add the missing languages
    logo_alt: 'The On logo',
    warning_unsaved_changes: 'Unsaved changes will be lost. Are you sure you want to leave this page?',
    ok_got_it: 'Ok, got it!',
    image_error: 'Image is not available',
    months: {
      January: 'January',
      February: 'February',
      March: 'March',
      April: 'April',
      May: 'May',
      June: 'June',
      July: 'July',
      August: 'August',
      September: 'September',
      October: 'October',
      November: 'November',
      December: 'December',
    },
    saving_orders: 'Saving your drafts, please wait...',
    submitting_orders: 'Submitting your orders, please wait...',
    partial_submit_title: 'Order Submission Summary',
    partial_submit_description: 'Some orders were submitted successfully while others encountered errors.',
    partial_submit_succeeded_section: 'Successfully submitted',
    partial_submit_failed_section: 'Failed to submit',
    partial_submit_go_to_orders: 'Go to orders',
    group_by: 'Group by',
  },
  contacts: {
    'Email us': 'Email us',
    'Hi On team! I have a question for you': 'Hi On team! I have a question for you',
    'Need to speak to someone? Contact us!': 'Need to speak to someone? Contact us!',
  },
  calendarPopup: {
    select_dates: 'Select date(s)',
    number_of_days_selected: '{numberOfDaysSelected} day(s) selected',
    one_initial_date_tip: 'You can copy quantity from initial date to other selected dates.',
    more_than_one_initial_date_tip:
      'All new dates will have 0 quantity, unselected dates will be removed and all their quantities will be cleared.',
    all_unselected_tip: 'All unselected dates will be removed and all their quantities will be cleared.',
    copy_quantities: 'Copy quantities',
  },
  createOrdersPopup: {
    main_title: 'New Order',
    subtitle:
      "An order cannot be submitted and will be only saved as a draft. Please reach out to the accounts receivables team  <a href='mailto:{accountReceivablesEmail}?subject=Order submission issue' target='_blank'>{accountReceivablesEmail}</a>",
    cancel_button: 'Cancel',
    create_button: 'Create',
    create_draft_button: 'Create a draft',
    shipping_date: 'Shipping date',
    contacts_title: 'Please choose one contact',
    contacts_roles: 'Roles',
    contact_has_no_roles: 'Contact has no roles',
    contacts_email: 'Email',
    order_types_title: 'Order type',
    disallowed_order_text:
      '現在、プレオーダーの出荷を最優先で対応している為、通常ご注文分の出荷の目処が立っておらず、Backstageからのご注文については一時的に停止させていただく予定となっております。 お客様には多大なご不便・ご迷惑をおかけしておりますこと、心より深くお詫び申し上げます。',
    order_type_pick_list_label_order: 'Order',
    'order_type_pick_list_label_last season': 'Last Season',
    order_type_pick_list_label_return: 'Return',
    'order_type_pick_list_label_re-order': 'Re-Order / Dropship',
    order_type_pick_list_label_warranty: 'Warranty',
    'order_type_pick_list_label_drop ship': 'Drop ship',
    'order_type_pick_list_label_pre-order': 'Pre-Order',
    order_type_pick_list_label_blockorder: 'Blockorder',
    order_type_pick_list_label_replacement: 'Replacement',
    order_type_pick_list_label_bulks: 'Bulks',
    'order_type_pick_list_label_experience shoes': 'Experience shoes',
    'order_type_pick_list_label_pre-order-multiple': 'Pre-Order (multiple ship dates)',
    "order_type_pick_list_label_dealer's staff shoes": "Dealer's staff shoes",
    'order_type_pick_list_label_special projects': 'Special Projects',
    select_contact: 'Select contact',
    requested_date_info: {
      'pre-order': '',
      'pre-order-multiple': '',
      'last season': '',
      're-order': 'Due to the tech migration orders can be placed for Jan 3rd the earliest',
      'special projects': '',
    },
  },
  matrix: {
    shoes: 'Shoes',
    apparel: 'Apparel',
    accessories: 'Accessories & Socks',
    ship_date_placeholder: 'Select ship date',
    total_all: 'Total All',
    items: 'items',
    total: 'Total',
    adapt_filters: 'Adapt filters',
    availability_tbd: 'TBD',
    tab_name: {
      'shoes-M': "Men's Shoes",
      'shoes-W': "Women's Shoes",
      'shoes-Y': "Youth's Shoes",
      'shoes-K': "Kid's Shoes",
      'shoes-T': "Toddler's Shoes",
      'shoes-U': 'Unisex Shoes',
      'apparel-M': "Men's Apparel",
      'apparel-W': "Women's Apparel",
      'apparel-U': 'Unisex Apparel',
      'accessories-U': 'Accessories & Socks',
    },
    tab_name_shoes: 'Shoes',
    tab_name_accessories_0: 'Accessories & Socks',
    tab_name_shoes_1: "Men's Shoes",
    tab_name_shoes_2: "Women's Shoes",
    tab_name_shoes_3: "Youth's Shoes",
    tab_name_shoes_4: "Kid's Shoes",
    tab_name_shoes_5: "Toddler's Shoes",
    tab_name_apparel: 'Apparel',
    tab_name_apparel_1: "Men's Apparel",
    tab_name_apparel_2: "Women's Apparel",
    tab_name_apparel_3: "Youth's Shoes",
    tab_name_apparel_4: "Kid's Shoes",
    product_launch_date: 'Launch',
    order_matrix_title: 'Order entry Matrix',
    return_matrix_title: 'Return entry Matrix',
    tab_name_accessories: 'Accessories & Socks',
    preorder_matrix_title: 'Pre-order entry Matrix',
    warranty_matrix_title: 'Warranty entry Matrix',
    'tab_name_accessories_-1': 'Accessories & Socks',
    availability_in_stock_on: 'In stock on',
    availability_matrix_title: 'Products Availability',
    availability_label_on_backorder: 'On backorder, to be delivered at a larger stage',
    availability_label_not_available: 'Not available for purchase',
    availability_label_item_available: 'Item available',
    remove_product_groups_items_button: 'Remove all items',
    availability_label_low_availability: 'Low availability',
    no_assortment:
      'It looks like there are no products available for this {orderType} order. If you think that is incorrect please contact your sales representative.',
    pre_order_phase_in_date_disabled: 'Change the date to a later one to be able to order this pre order item',
    pre_order_carry_over_disabled: 'The earliest possible Requested date for this item is 15 days from start of season',
    return_missing_products: "Don't see the product you are looking for? Please reach out to your sales rep",
    warranty_missing_products:
      "Don't see the product you are looking for? Please reach out to our happiness delivery team",
    error: {
      missing_fields_preorder:
        '<span class="snotify-icon snotify-icon--warning"></span>Some of the tabs are missing quantity or ship date.',
      warranty_max_products: 'max of 50 items per warranty case has been reached',
      no_products_available: 'No products available for the selected date and order type',
      max_bulk_orders_reached: 'Maximum of {max} pre-orders per bulk submission has been reached',
    },
    product_group_search_placeholder: "Search for 'Cloudflow' or '60.000' ",
    increase_quantities_is_not_allowed:
      'Given you are editing a {orderType} order outside of the sell-in period, increasing quantities is disabled.',
    jump_to: 'Jump to',
    requested_date: 'Requested date',
    select_quantities: 'Select quantities',
    'no products were found while searching': 'No products were found while searching',
    retailer_price: 'RRP',
    wholesale_price: 'WSP',
    total_retailer_price: 'Total RRP',
    total_wholesale_price: 'Total WSP',
    total_quantities: 'Total quantities',
    show_wholesale_price: 'Show WSP',
    hide_wholesale_price: 'Hide WSP',
    change_size_units: 'Change size units',
    change_unit_size: 'Change unit size',
    size_label: 'Size',
    change: 'Change',
    sneaker_program_tooltip_title: 'SNEAKER PROGRAM',
    mca_tooltip_title: 'Minimum Credible Assortment',
    max_quantity_tooltip: 'Max: {max}',
    group_by: {
      Model: 'Model',
      'Shipping date': 'Shipping date',
    },
    excel_upload: 'Excel upload',
    download_template: 'Download Excel Template',
    downloading_template: 'Downloading...',
    upload_template: 'Upload Excel Template',
    uploading_template: 'Uploading...',
    upload_reason: 'Reason',
    upload_warning_title: 'Upload Excel Template',
    upload_warning_message:
      'Uploading an Excel template will overwrite all current quantities in the quantity selector. Are you sure you want to continue?',
    upload_warning_confirm: 'Continue',
    upload_warning_cancel: 'Cancel',
    toast: {
      title: {
        order_type_changed: 'Order type changed',
        success: 'Success!',
      },
      message: {
        order_type_changed: 'Multiple date/PO combinations detected — switched to Multiple Pre-Order.',
        success: 'All your items have been uploaded to your order.',
      },
    },
    excel_template: {
      instructions_sheet_name: 'Instructions',
      order_template_title: 'Order Template',
      account_id: 'Account ID',
      season_start_date: 'Season Start Date',
      season_end_date: 'Season End Date',
      exgo_window_start_date: 'Exgo Window Start Date',
      exgo_window_end_date: 'Exgo Window End Date',
      no_end_date: 'No end date',
      instructions_label: 'Instructions:',
      instruction_1:
        'Each tab contains products for a specific category and gender (Shoes-Men, Shoes-Women, Apparel-Men, Apparel-Women)',
      instruction_2: 'Green cells are editable — enter your desired quantities there',
      instruction_3:
        'Orange cells are for the Requested Receipt Date — enter dates in {format} format and customer PO number.',
      instruction_3_exgo: 'Orange cells are for the Exgo Date — enter dates in {format} format and customer reference.',
      instruction_4: 'Customer PO Number column accepts up to {max} characters',
      instruction_5: 'Gray cells indicate unavailable sizes',
      instruction_6: 'Do not modify the structure of the sheets (do not add/remove columns or rows)',
      instruction_7: 'Please do not add any formulas or special formatting to the sheets',
      product_group: 'Product Group',
      item_number: 'Item Number',
      color: 'Color',
      gender: 'Gender',
      launch_date: 'Launch Date',
      wholesale_price: 'Wholesale Price',
      requested_receipt_date: 'Requested Receipt Date',
      exgo_date: 'Exgo Date',
      customer_po_number: 'Customer PO Number',
      customer_reference: 'Customer Reference',
      total: 'Total',
      total_price: 'Total Price',
      retailer_price: 'RRP',
      total_retailer_price: 'Total RRP',
      no_products: 'No products available for this category',
      size_label: 'Size',
      date_prompt_title: 'Requested Receipt Date',
      exgo_date_prompt_title: 'Exgo Date',
      date_prompt: 'Enter a date between {start} and {end}',
      exgo_date_prompt: 'Enter an Exgo date between {start} and {end}',
      date_error_title: 'Invalid Date',
      date_error: 'Date must be between {start} and {end}',
      exgo_date_error_title: 'Invalid Exgo Date',
      exgo_date_error: 'Exgo Date must be between {start} and {end}',
      po_prompt_title: 'Customer PO Number',
      customer_reference_prompt_title: 'Customer Reference',
      customer_reference_prompt: 'Enter a customer reference with up to {max} characters',
      po_prompt: 'Enter a PO number with up to {max} characters',
      po_error_title: 'Invalid PO Number',
      customer_reference_error_title: 'Invalid Customer Reference',
      customer_reference_error: 'Customer reference must be {max} characters or less',
      po_error: 'Customer PO number must be {max} characters or less',
      quantity_error_title: 'Invalid Quantity',
      quantity_error: 'Please enter a whole number >= {min}',
      moq_error_title: 'Minimum Order Quantity',
      moq_error: 'Minimum {min} items per barcode for this category',
      no_limit: 'no limit',
      gender_unisex: 'Unisex',
      gender_men: 'Men',
      gender_women: 'Women',
      gender_youth: 'Youth',
      gender_kids: 'Kids',
      gender_toddler: 'Toddler',
      category_shoes: 'Shoes',
      category_apparel: 'Apparel',
      category_accessories: 'Accessories',
    },
  },
  excel_order_upload: {
    overwrite_warning_modal: {
      title: 'Careful, current quantities will be overwritten.',
      description:
        'Uploading an Excel template will overwrite all current quantities in the quantity selector. Are you sure you want to continue?',
      button_label: {
        cancel: 'Cancel',
        continue: 'Continue',
      },
    },
    excel_upload_modal: {
      title: 'Upload excel file',
      description:
        'Upload your filled order file and let Backstage select your items, dates and quantities from it. Careful any item already filled will be erased.',
      instruction: 'Drag and drop your .xlsx here. (Max file size : {max})',
      or: 'or',
      button_label: {
        browse_files: 'Browse files',
        download_template: 'Download template',
        upload: 'Upload',
      },
      error: {
        file_size_too_big: 'Maximum file size is {max_file_size}.',
        wrong_file_type: 'Supported file is .xlsx.',
        download_template_error: 'Failed to download the template. Please try again.',
      },
    },
    partial_success_modal: {
      title: 'Partial success.',
      description: "Some of those entries couldn't be loaded.",
      button_label: {
        discard: 'Discard upload',
        proceed: 'Proceed',
        copy: 'Copy all clipboard',
        download: 'Download as excel',
      },
    },
    validation_error: {
      reasons: {
        upload_product_not_found: 'Unrecognizable style numbers',
        upload_product_not_in_assortment: 'Items out of your assortment',
        upload_date_before_season_start: 'Requested receipt date is before season start',
        upload_date_after_season_end: 'Requested receipt date is after season end',
        upload_product_not_available: 'Unavailable date',
        upload_size_not_available: 'Non existing sizes',
        upload_below_minimum_quantity: 'Quantity below minimum order quantity of {minimum}',
        upload_exceeds_maximum_quantity: 'Quantity above maximum order quantity of {maximum}',
        upload_no_processable_sizes: 'No processable sizes for item.',
        upload_requested_receipt_date_missing: 'Requested receipt date is required',
        upload_exgo_date_missing: 'Exgo date is required',
        upload_dist_date_before_window: 'Exgo date is before the allowed window for this season',
        upload_dist_date_after_window: 'Exgo date is after the allowed window for this season',
      },
    },
    upload_error_modal: {
      title: 'Upload failed',
      description: {
        upload_template_error: 'Failed to process the uploaded template. Please try again.',
        upload_error_tampered: 'This template has been modified and cannot be verified.',
        upload_error_wrong_account: 'The template uploaded was generated for a different account',
        upload_no_valid_rows: 'No valid row to apply. Please check your template and try again.',
        no_products_available: 'No products available for the selected date and order type',
        missing_season_info: 'Season information is missing. Please refresh the page and try again.',
      },
      button_label: {
        close: 'Close',
        back_to_upload: 'Back to upload',
      },
    },
    bulk_orders_truncated: 'Your file contained {total} order groups. Only the first {max} were imported.',
  },
  create_edit_order: {
    add_to_order: 'Add to order',
    remove_from_order: 'Remove from order',
    breadcrumb_menu: {
      'products-selection': 'Product selection',
      quantities: 'Quantities',
      'order-details': 'Order details',
    },
    order_edit_timeout_info: {
      info: 'Editing order is possible until',
      description: 'Beyond this time this order will no longer be editable.',
      warning: 'You are about to run out of time. Submit your edits before',
      timeout: 'You run out of time.',
    },
    'execute_products-selection_step_button': 'Select quantities',
    execute_quantities_step_button: 'View order details',
    'execute_order-details_step_button': 'Submit',
    execute_save_draft_button: 'Save as draft',
  },
  create_edit_case: {
    add_to_order: 'Add to order',
    remove_from_order: 'Remove from order',
    breadcrumb_menu: {
      'products-selection': 'Product selection',
      quantities: 'Quantities',
      details: 'Details',
    },
    case_type: {
      return: 'Return',
      warranty: 'Warranty',
    },
    'execute_products-selection_step_button': 'Select quantities',
    execute_quantities_step_button: 'Details',
    execute_details_step_button: 'Submit',
  },
  products_availability: {
    title: 'Availability',
    breadcrumb_menu: {
      'products-selection': 'Product selection',
      quantities: 'Availability',
    },
    'execute_products-selection_step_button': 'Continue',
  },
  header: {
    nav: {
      menu: 'Menu',
      orders: 'Orders',
      availability: 'Availability',
      accounting: 'Accounting',
      returns: 'Returns',
      warranty_cases: 'Warranties',
      return_cases: 'Returns',
      products: 'Products',
      marketing: 'Marketing',
      marketing_hub: 'Marketing hub',
      marketing_library: 'On Marketing Library',
      about: 'About On',
      events: 'Events',
      news: 'News',
      transparency: 'Transparency',
      bootcamp_app: 'Partner Bootcamp App',
      technology: 'On Technology',
      dashboards: 'Dashboards',
      contact: 'Contact us',
      help_center: 'Help Center',
      admin: 'Admin',
    },
    account: {
      log_out: 'Log out',
    },
    notification: {
      title: 'Notifications',
      setting: 'Notification settings',
      order_shipped: 'Order shipped',
      order_shipped_body: 'Your order {orderNumber} has been shipped.',
      no_notifications_title: 'No notifications',
      no_notifications_body: 'There is no new notifications',
      chip: '{unreadNumber} New',
      mark_all_as_read: 'Mark all as Read',
      channel_header: {
        in_app: 'In App',
        email: 'Email',
      },
      settings: {
        order_shipped: 'Order shipped',
      },
    },
  },
  config: {
    in_availability_label: 'In Stock',
    low_availability_label: 'Low Stock',
    very_low_availability_label: 'Very Low Stock',
    no_availability_label: 'No Stock',
  },
  forms: {
    options: {
      noOptionsFound: 'No options found',
      yesNoOptions: {
        yes: 'Yes',
        no: 'No',
      },
      lengthUnits: {
        mm: 'mm',
        cm: 'cm',
        m: 'm',
        in: 'in',
        ft: 'ft',
        yd: 'yd',
      },
      weightUnits: {
        mg: 'mg',
        g: 'g',
        kg: 'kg',
        t: 't',
        oz: 'oz',
        lb: 'lb',
        st: 'st',
        sht: 'sht',
      },
    },
  },
  formsValidations: {
    fields: {
      default_required: '*',
      comments: 'comments',
      delivery_name: 'name',
      street_address: 'street address',
      city: 'city',
      state: 'state',
      post_code: 'post code',
      distance_run: 'distance run',
      defect_reason: 'defect reason',
      purchase_date: 'purchase date',
      product_code: 'production code',
      factory_code: 'factory code',
      return_reason: 'return reason',
      return_description: 'comment',
      customer_po_number: 'Customer PO #',
      contact_name: 'contact name',
      phone_number: 'phone number',
      consignee_email: 'consignee email',
      parcels_total_weight: 'parcels total weight',
      individual_parcel_weight: 'individual parcel weight',
      parcel_width: 'parcel width',
      parcel_height: 'parcel height',
      parcel_length: 'parcel length',
      collection_date: 'collection date',
      responsibility_acceptance: 'Acceptance of this responsibility is required',
      one_pallet_or_parcel: 'At least one parcel or one pallet must be specified',
      invalid_single_package_weight: "Single package weight can't exceed total package weight",
      return_parcel_count: 'parcel count',
      parcels: 'Number of parcels',
      pallets: 'Number of pallets',
    },
    rules_error_messages: {
      required: 'The {field} field is required',
      email: 'Type a valid email',
      min_chars: '{field} has to be at least {min_chars} characters long',
      max_chars: "{field} can't exceed {max} characters",
      min_value: '{field} should be at least {min_value}',
      max_value: "{field} can't exceed {max_value}",
      min_date: '{field} should be at least {min_date}',
      max_date: '{field} should be at least {max_date}',
    },
  },
  viewFaqs: {
    page_title: 'Help Center',
    search_placeholder: 'Search',
    title: 'FAQs',
    video_tutorials: 'Video tutorials',
    expand_button: {
      see_more: 'See more',
      see_less: 'See less',
    },
    minute: 'min',
    minutes: 'mins',
  },
  login: {
    go_to_login: 'Back to login',
    header: 'The one stop shop for On Partners',
    subheader_one: 'The one-stop shop for On partners',
    subheader_two: 'The hub for everything On',
    header_description:
      'Place orders and claims 24/7, check product availability or download the latest marketing assets -- all in one place, all at your fingertips -- helping you streamline your business.',
    username: 'Username',
    password: 'Password',
    log_in_button: 'Log in',
    form_header: 'Log in',
    create_account: 'Need an account? {contact_us_link} and we will set you up.',
    contact_us: 'Contact us',
    background_image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/32TvOYKIdYt9430yr6X7I0/a7fd2d9094c8f7f8ef9aa5dbe11524dc/login-background.jpg',
    reset_password_link: 'Forgot password?',
    sales_rep_login: 'Sales rep login',
  },
  oauthLogin: {
    header: 'Log in via Salesforce',
    in_progress: 'Logging in...',
  },
  resetPassword: {
    header: 'Reset your password',
    form_header: "Please enter your username and we'll email you a link to reset your password.",
    username: 'Your username',
    button_label: 'Reset password',
    background_image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/59sVQnA68DMnjBshzYnuej/466de5f28ce1225c8c80606990db4750/background.jpg',
  },
  createPassword: {
    header: 'Create your password',
    form_header: 'Enter a new password for {username}. Make sure to include at least:',
    password_rule_length: '8 characters',
    password_rule_letters: '1 letter',
    password_rule_numbers: '1 number',
    password: 'New password',
    confirm_password: 'Confirm new password',
    button_label: 'Create password',
    background_image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/59sVQnA68DMnjBshzYnuej/911aa48eabee5b3b3f768392c35133ed/background.jpg',
    empty_checkbox_image_alt: 'An empty checkbox, indicating that your password does not meet this requirement',
    filled_checkbox_image_alt: 'A checkbox indicating that your password meets this requirement',
  },
  paymentEmailSubscription: {
    header: 'Payment email subscription',
    background_image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/59sVQnA68DMnjBshzYnuej/911aa48eabee5b3b3f768392c35133ed/background.jpg',
    success_message: 'Payment email successfully unsubscribed',
    error_message: 'Something went wrong, payment email is not unsubscribed',
  },
  shipmentEmailUnSubscription: {
    header: 'Shipment email subscription',
    background_image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/59sVQnA68DMnjBshzYnuej/911aa48eabee5b3b3f768392c35133ed/background.jpg',
    success_message: 'Shipment email successfully unsubscribed',
    error_message: 'Something went wrong, shipment email is not unsubscribed',
  },
  backend: {
    access: {
      account_access_forbidden: 'You do not have access to the account you were trying to access.',
      account_access_log_out_required: 'Due to a recent change, you need to log out and back in again.',
      account_access_sales_rep_no_accounts:
        'You must be the owner of at least one Salesforce account before you can log into Backstage.',
      season_not_available_for_account: 'This season is currently not available for this account.',
    },
    accounts: {
      import_invalid_type: 'Invalid account import type.',
    },
    drafts: {
      seasons_missing: 'There is no season for this order.',
      incorrectQuantity:
        'All lines should have a selected quantity. Clearing your browser cache, and editing & saving your draft should fix the error',
      notUniqueLines: 'There is more than one line with the same product',
      sales_order_disabled: 'Sales order creation / modification is currently disabled for this account.',
      lines_required: 'At least one line is required to create a draft.',
      lock_failed: 'Draft could not be locked for submission.',
      bulk_creation_failed: 'An error occurred while creating drafts. Please try again.',
      bulk_update_failed: 'An error occurred while updating drafts. Please try again.',
      re_order_disabled_for_account: 'Re-order creation is currently disabled for this account.',
      season_disabled_for_account: 'Orders for this season are currently disabled for this account.',
    },
    login: {
      login_failed: 'Your username and/or password were incorrect. Please try again.',
      login_failed_unknown: 'There was an unknown error trying to log you in. Please try again later.',
      login_attempt_blocked:
        'Your account has been blocked due to too many failed login attempts. Please wait up to 10 minutes and then try again.',
      no_accounts: 'Your account is not properly configured yet, please contact your sales representative.',
      password_update_successful: 'Your password was successfully updated! You can now use it for your next login.',
      password_reset_failed_unknown: 'Ups an unknown error occurred, please contact customer service',
      password_reset_expired_token: 'The password reset link has expired. Please request a new one.',
      password_reset_invalid_token: 'The password reset link is invalid. Please request a new one.',
      password_reset_new_password_invalid: 'The new password does not meet the requirements. Please try again.',
      password_reset_new_password_repeated: 'This password has been used before. Please choose a different password.',
      reset_password_confirmation_message:
        'An email with password reset instructions will be sent if the provided username exists.',
      sf_session_bridge_login_failed: 'Failed to log in via Salesforce. Please try again.',
      sf_session_bridge_user_not_found: 'User not found. Please contact your administrator.',
      user_deactivated: 'Your account has been deactivated. Please contact your administrator.',
      user_backstage_v2_not_eligible: 'You are not eligible to switch to Backstage V2.',
    },
    oauth_login: {
      attempt_expired: 'It looks like you may be trying to log in with an old link. Please start over.',
      attempt_failed_unknown: "We couldn't log you in for an unknown reason. Please try again.",
      wrong_organization_id: 'It looks like you may be trying to log from wrong salesforce. Please start over.',
    },
    orders: {
      fetch_order_error: 'Order not found',
      fetch_draft_error: 'Draft not found',
      update_order_error: 'Internal error occurred! Your order was not updated.',
      submit_order_error: 'Internal error occurred! Your order was not submitted: {orders}',
      save_draft_error: 'Internal error occurred! Your draft was not saved.',
      delete_draft_error: 'Internal error occurred! Your draft was not deleted.',
      missing_season: 'There is an issue identifying the season of your order, so we cannot process your update.',
      missing_sell_in_period: 'The season is missing sell-in period information.',
      missing_products: 'The order is missing products.',
      order_not_found: 'Order not found.',
      update_in_progress: 'An order update is already in progress. Please wait and try again.',
      update: {
        incorrect_order_status:
          'You can only update an order when the status is open / hold and the document status is confirmation.',
        incorrect_document_status: 'The order document status does not allow updates.',
        products_not_editable: 'You cannot add new products for preorders outside of selling period',
        cannot_increase_quantities: 'You cannot increase quantities for preorders outside of selling period',
        not_allowed: 'Only sales representatives can update orders.',
        save_failed: 'Failed to save order update.',
        dealer_update_failed: 'Dealer update failed.',
        stale_update: 'The order has been updated by another user. Please refresh and try again.',
        update_line_missing: 'The order line you are trying to update is missing.',
      },
    },
    validation: {
      cannot_be_empty: 'You must add at least one product',
      invalid_value: 'The value provided is invalid.',
      missing_field: '{fieldName} is required.',
      amount_mismatch: 'It looks like the total amount has changed, please refresh the page and try again.',
      invoice_not_payable:
        'It looks like one of the invoice you picked is not payable anymore, please go back to accounting page and select documents again.',
      payment_details_failed: "It looks like something didn't go as expected with the checkout. Please try again.",
      max_items_reached:
        'There are more than allowed products in this case. 50 is the max for warranty and 500 for returns.',
      PO_number_too_long: 'PO number is too long, Please reduce it to 20 characters.',
      unexpected_error: 'An unexpected error occurred. Please try again.',
      invalid_origin: 'The origin value is incorrect.',
      account_on_hold: 'Your account is currently on hold.',
      invalid_drop_ship_address: 'The drop ship address is invalid.',
      invalid_account: 'The account is invalid.',
      invalid_date: 'The date provided is invalid.',
      product_required: 'At least one product is required.',
      rollback_failed: 'Failed to rollback the transaction.',
      max_documents_limit_reached: 'You can select a maximum of 20 documents.',
      import_invalid_type: 'Invalid account import type.',
      test_error: 'Test error for spec/mock files.',
      unspecified_error_creating: 'An unspecified error occurred during creation.',
      contact_id_required: 'Contact ID is required.',
      reference_id_missing: 'Reference ID is missing.',
      voucher_missing: 'Voucher is missing.',
      customer_number_missing: 'Customer number is missing.',
      total_document_amount_missing: 'Total document amount is missing.',
      excel_generation_error: 'An error occurred while generating the Excel file. Please try again.',
      invalid_dynamics_account_number: 'Account does not have a valid Dynamics account number.',
      due_date_past_season_end: 'Due date is invalid as it is past the season end date.',
      currency_code_missing: 'Currency code is missing.',
    },
    payments: {
      account_not_found: 'Account not found.',
      no_merchant_account_found: 'No merchant account found for this account.',
      payment_error: 'An error occurred while making payment.',
    },
    cases: {
      image_too_big: 'Image size is bigger than supported 2mb.',
      image_type_already_exists: 'An image of this type has already been uploaded.',
      image_format_not_accepted:
        'The image format is not accepted, please use one of the following formats => jpg, png, gif, webp, svg',
      images_too_many: 'You can only upload up to three images',
      unspecified_error_updating: 'Sorry there was an unspecified error, please try again later',
      unspecified_error_creating: 'Sorry there was an unspecified error creating the case, please try again later',
      not_updatable: 'This case cannot be updated.',
      unknown_line: 'The case line being updated does not exist.',
      unknown_case: 'The case being updated does not exist.',
      line: {
        does_not_exists: 'You are trying to delete an already removed product',
        delete_line_error: 'There was an error deleting the case line, please try again later',
      },
      save_case_error: 'There was an error saving the case, please try again later',
      submit_case_error: 'There was an error submitting the case, please try again later',
      delete_case_error: 'There was an error deleting the case, please try again later',
      submission_error: 'Error submitting case.',
      update_case_error: 'Error updating case.',
      invalid_case_type: 'Invalid case type: {type}',
      images_required: 'Images are required for this warranty case.',
    },
    contentful: {
      error_adding: 'Error trying to add {entity} in Contentful.',
      error_adding_with_id: 'Error trying to add {entity} in Contentful, with id {id}.',
      error_updating: 'Error trying to update {entity} in Contentful.',
      error_updating_with_id: 'Error trying to update {entity} in Contentful, with id {id}.',
    },
    pricat: {
      account_not_found: 'We could not find your account, please contact your sales representative.',
      user_has_no_access_to_account: 'You do not have access to the account you were trying to create PRICAT for.',
      global_pricat_not_found: 'The global PRICAT for the requested season does not exist.',
      season_not_found: 'The provided season could not be found.',
      assortment_not_found: 'The account has no assortment available.',
      account_pricat_not_found: 'The account PRICAT for the requested season does not exist.',
    },
    unspecified_error_updating: 'An unspecified error occurred while updating.',
    dynamics_account_number_missing: 'The Dynamics account number is missing.',
    account_number_missing: 'The account number is missing.',
    account_missing: 'The account was not found in the database.',
    user_missing: 'User information is missing.',
    user_not_found: 'User not found.',
    user_insufficient_permissions: 'You do not have sufficient permissions to access this section.',
    page_not_found: 'The page you are looking for does not exist.',
    season_not_found: 'The season could not be found.',
    address: {
      save_failed: 'Failed to save the address.',
    },
    products: {
      barcode_missing: 'Barcode is missing.',
      size_missing: 'Size is missing.',
      size_group_missing: 'Size group is missing.',
      name_missing: 'Name is missing.',
      color_code_missing: 'Color code is missing.',
      color_name_missing: 'Color name is missing.',
      gender_missing: 'Gender is missing.',
      main_group_missing: 'Main group is missing.',
      product_group_name_missing: 'Product group name is missing.',
      product_group_number_missing: 'Product group number is missing.',
      image_url_missing: 'Image URL is missing.',
      skipping_female_apparel_xxs: 'Skipping import of female apparel product in XXS size.',
      cpa_adaption_level_unsupported: 'This action is not supported in the current product data configuration.',
    },
    self_sell_in: {
      page_not_found: 'The page you are looking for does not exist.',
    },
    order_lines: {
      seasons_required: 'Seasons are required.',
      query_required_for_multiple_seasons: 'A search query is required when requesting multiple seasons.',
      invalid_season_code: 'One or more of the requested seasons could not be recognized.',
      limit_too_high: 'The requested limit is too high.',
      limit_invalid: 'The requested limit is invalid.',
      season_fetch_failed: 'We could not load orders for one or more seasons. Please try again.',
      all_seasons_failed: 'We could not load your orders right now. Please try again later.',
    },
  },
  viewHome: {
    account: {
      your_account_manager: 'Your account manager',
    },
    view_all_orders: 'View all orders',
    place_new_order_button: 'Place new order',
    unsubmitted_orders_title: 'Latest unsubmitted orders',
    check_availability_button: 'Check availability',
    no_unsubmitted_orders_message: 'No unsubmitted orders were found',
  },
  footer: {
    home: 'Home',
    nav_title: 'On Backstage',
    about: 'About On',
    about_url: 'https://clouds.on-running.com/en-us/about',
    consent_settings: 'Consent settings',
    press_media: 'Press Media',
    press_media_url: 'https://www.on-running.com/articles',
    company_information: 'Company information',
    company_information_url: 'https://clouds.on-running.com/en-us/company',
    contact: 'Contact us',
    privacy_policy: 'Privacy Policy',
    privacy_policy_url: 'https://clouds.on-running.com/en-us/privacy',
    language: 'Language',
    report_bug: 'Report a bug',
    switzerland: 'Switzerland',
  },
  documentsCheckout: {
    title: 'Checkout documents',
    select_payment_method: 'Select payment method',
    documents_details: 'Document details',
    document_number: 'Document',
    document_amount: 'Amount',
    total_details: 'Total details',
    total: 'Documents total',
    document_is_not_available:
      'Unfortunately the document is not available at the moment, please try again later or contact us.',
    credit_card_not_supported:
      'Credit card not supported, please use one of the supported credit cards => visa, master card, maestro',
    submit_payment_success: 'The payment was completed correctly',
    'ACH Direct Debit': 'ACH Direct Debit',
    'Credit Card': 'Credit Card',
    payment_method: {
      scheme: 'Your balance has reached {limit} limit. To complete this transaction, use a different payment method.',
      ach: 'Using this payment method will not affect your credit card limit.',
    },
    billing_address: 'Billing address',
    scheme: 'Card',
    ach: 'Ach Direct Debit',
    threeds_payment_failed:
      'The payment process went through 3d secure checkout that failed, please try again with a different payment method or card. Contact us if the problem persists',
  },
  billingAddressForm: {
    street: 'Street',
    city: 'City',
    state: 'State',
    house_number: 'House number',
    post_code: 'Post code',
    country: 'Country',
    state_province: 'State/Province',
    select_country: 'Select country',
    select_state_province: 'Select state/province',
  },
  marketing: {
    title: 'The one',
    subtitle: 'Stop shop for On Partners',
    banner_button: 'See all assets',
    card_button: 'See more',
  },
  successOrderedMessage: {
    submitted: 'submitted',
    will_receive: "You'll receive a confirmation email shortly at",
    update_success_message: 'Updates are sent. Please note that it can take up to 30 minutes to be processed',
    track_order: "Within 24 hours you'll be able to track your order",
    okay: 'Okay',
    editing_order_info: 'Editing order is still possible for the next 30 mins',
    edit_order: 'Edit order',
    image_url:
      'https://images.ctfassets.net/hnixxj5aj0lz/71HZIWZbiMbWKouUL0Nafa/af0205aa745f598baefb221cd137e03d/success-background.jpeg',
  },
  returnCaseForm: {
    addressNotes: 'Address notes',
    addressNotesErrorMessage: "Address notes can't exceed {max_chars} characters.",
    contactName: 'Contact name for pick up',
    phoneNumber: 'Phone number of contact',
    consigneeEmail: 'Consignee email',
    customerReference: 'Customer reference',
    locationRestricted: 'Restricted access at location',
    tailLift: 'Tail lift required',
    specialInstructions: 'Special instructions/ comments',
    collectionDate: 'Preferred collection date',
    parcels: 'Number of parcels',
    pallets: 'Number of pallets',
    units: 'Units',
    parcelsWeight: 'Total weight of parcels',
    individualParcelWeight: 'Weight of an individual parcel',
    parcelWidth: 'Width of an individual parcel',
    parcelHeight: 'Height of an individual parcel',
    parcelLength: 'Length of an individual parcel',
    yesOption: 'Yes',
    noOption: 'No',
    responsibilityMessage:
      'I hereby take all responsibility for any cost escalations, delays, omissions or failures in consignment collection/delivery, that have been caused by erroneous/incomplete address details provided by me.',
    datepickerTooltip: 'Collection will happen 24 to 48h after booking',
    lengthUnits: {
      mm: 'mm',
      cm: 'cm',
      m: 'm',
      in: 'in',
      ft: 'ft',
      yd: 'yd',
    },
    weightUnits: {
      mg: 'mg',
      g: 'g',
      kg: 'kg',
      t: 't',
      oz: 'oz',
      lb: 'lb',
      st: 'st',
      sht: 'sht',
    },
  },
  admin: {
    retry: 'Retry Orders',
    resubmit_cases: 'Resubmit Cases',
    delete: 'Delete Orders',
    retry_placeholder: 'Order numbers to retry',
    resubmit_cases_placeholder: 'Case numbers to resubmit',
    delete_placeholder: 'Order numbers to delete',
    welcome: 'Backstage admin section',
    copy_order_numbers: 'Copy filtered order numbers',
    orders_correctly_set_to_be_retried: 'Orders correctly set to be retried: ',
    cases_resubmitted: 'Following Case(s) submitted successfully. ',
    error_resubmitting_cases: 'Case(s) could not be resubmitted. Please check the case status and try again',
    orders_correctly_deleted: 'Orders statuses correctly set to deleted: ',
    health: {
      title: 'Health',
      financialSystemsSynch: 'Finance Systems',
      operationalSystemsSynch: 'Operational Systems',
      usersLogin: 'User Login',
      ordersSubmission: 'Order Submission',
      status: {
        ok: 'Operational',
        warning: 'Disrupted',
        error: 'Outage',
      },
    },
    productStyleException: {
      title: 'Product Style Exceptions',
    },
    exceptionReports: {
      title: 'Exception Reports',
      generateRegionalReport: 'Generate Regional Exception Report',
      generateSeasonalReport: 'Generate Seasonal Exception Report',
      selectSeason: 'Select season',
      seasonalReportInfo:
        'The seasonal report may take several minutes to generate. Only one report can be generated at a time.',
      reportAlreadyInProgress:
        'A seasonal exception report is already being generated. Please wait for it to complete before requesting another.',
      reportGenerationFailed: 'Failed to generate the seasonal exception report. Please try again later.',
    },
    cache: {
      title: 'Cache',
      pattern_placeholder: 'Key pattern (e.g. orders*)',
      search: 'Search',
      clear_all: 'Clear Entire Cache',
      clear_all_confirm: 'This will permanently delete ALL cache keys. Are you sure you want to continue?',
      delete_selected: 'Delete Selected',
      delete_selected_confirm: 'Are you sure you want to delete the selected cache keys?',
      keys_deleted: 'Cache keys deleted successfully.',
      cache_cleared: 'Cache cleared successfully.',
      error_deleting_keys: 'Could not delete the selected cache keys. Please try again later.',
      error_clearing_cache: 'Could not clear the cache. Please try again later.',
      load_more: 'Load More',
      key_column: 'Key',
      no_keys_found: 'No cache keys found.',
    },
  },
  viewSelfSellIn: {
    error_loading: 'Something went wrong while loading this page. Please try again later.',
    hero_banner: {
      back_button: 'Back to Backstage',
      season_catalog: 'Season catalog',
      commercial_overview: 'Commercial overview',
    },
    important_dates: {
      add_to_calendar: 'Add to calendar',
    },
    welcome_video: {
      watch_video: 'Watch video',
      video_title: 'Welcome video',
    },
    catalog_download: {
      pricat_section_title: 'Download your PRICAT',
      download_error: 'There was an error downloading {fileName}',
      season_missing: 'The current season is not be found.',
      missing_url: 'There is no URL to open.',
      button_downloading: 'Downloading',
    },
    video_carousel: {
      video_count: '1 video | {count} videos',
    },
    contact_info: {
      contact: 'Get in touch',
      title: 'Contact information',
    },
    back_link: {
      title: 'Hey, are you ready?',
      subtitle: 'Just head back to Backstage and place your order then!',
      back_text: 'Back to Backstage',
      start_to_order: 'Start to Order',
      bg_image_url:
        'https://library.on.com/m/7e08ea55df6289ee/webimage-ss25-lightspray-pr-portrait_still-cloudboom_strike_ls_dominic_lobablu-06.png',
    },
  },
  seasonCatalogPdf: {
    error: {
      data_not_found: 'Catalog data is not found for this account or for this season',
      error_while_generation: 'There was an error while generating a season catalog',
    },
    legend: {
      title: 'Icons Legend',
      general_information: 'General Information',
      labels_on_product: 'Labels on Product',
      size: 'Size',
      weight: 'Weight (g)',
      heel_to_toe_offset: 'Heel to toe offset',
      new: 'New',
      preorder_only: 'Preorder only',
      key_item: 'Key Item',
      carry_over: 'Carry Over',
    },
    labels: {
      new: 'New',
      pre_order_only: 'Preorder only',
      key_item: 'Key item',
      carry_over: 'Carry over',
    },
    specs: {
      size: 'Size',
      weight: 'Weight (g)',
      heel_to_toe_offset: 'Heel to toe offset',
    },
    prices: {
      wsp: 'WSP',
      rrp: 'RRP',
    },
  },
  validation: {
    account_not_found: 'Account details not found',
  },
};
